import { DateTime } from 'luxon';

/**
 * Parses an ISO 8601 string into a Luxon DateTime, or null if the value is
 * blank or not a valid ISO instant. Shared primitive used by toDuration and
 * parseOptionalDateFromUnknown.
 *
 * @param value - Raw string; leading and trailing whitespace is ignored
 */
export function parseOptionalLuxonDateTimeFromIsoString(
	value: string,
): DateTime | null {
	const trimmed = value.trim();

	if (trimmed.length === 0) {
		return null;
	}

	const dateTime = DateTime.fromISO(trimmed);

	if (!dateTime.isValid) {
		return null;
	}

	return dateTime;
}
